import { render, staticRenderFns } from "./farmingReminder.vue?vue&type=template&id=0d5530de&scoped=true"
import script from "./farmingReminder.vue?vue&type=script&lang=js"
export * from "./farmingReminder.vue?vue&type=script&lang=js"
import style0 from "./farmingReminder.vue?vue&type=style&index=0&id=0d5530de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5530de",
  null
  
)

export default component.exports